import { useEffect } from 'react'

import { Matricula } from 'src/tipos'

import { trackMatricula } from './matricula'

const ETAPA_POR_PASSO: Record<number, string> = {
  1: 'DadosPessoais',
  2: 'DadosPlanoPagamento',
  3: 'TermosECondicoes',
  4: 'DadosPagamento'
}

interface UseMatriculaAnalyticsParams {
  /** `true` somente para o fluxo de pós (ModoMatricula.Pos). */
  ehFluxoPos: boolean
  passo: number
  matricula?: Matricula
}

/**
 * Efeitos de analytics do wizard de matrícula:
 * - Abandono (best-effort): registra a etapa em que o aluno estava ao fechar a
 *   aba. Só refina o funil — a desistência é medida por etapa_iniciada/concluida.
 * - Limpa as super properties do Mixpanel ao sair do fluxo de matrícula.
 */
export const useMatriculaAnalytics = ({
  ehFluxoPos,
  passo,
  matricula
}: UseMatriculaAnalyticsParams): void => {
  useEffect(() => {
    if (!ehFluxoPos) return

    const aoSair = () => {
      trackMatricula.etapaAbandonada({
        etapa: ETAPA_POR_PASSO[passo] ?? `passo_${passo}`,
        forma_selecionada:
          matricula?.planoPagamento?.formPagamentoParcela ?? null
      })
    }

    window.addEventListener('beforeunload', aoSair)
    return () => window.removeEventListener('beforeunload', aoSair)
  }, [ehFluxoPos, passo, matricula])

  useEffect(() => {
    return () => {
      if (ehFluxoPos) {
        trackMatricula.limparContexto()
      }
    }
  }, []) //eslint-disable-line
}
